import {hitGoogleTagManager} from "./gtm_init";

export const gtmOfferBoxGalleryArrowClick = () => {
    const gtmData = {
        event: "gallery_arrow_click"
    };
    hitGoogleTagManager(gtmData);
};
